import { memo as Memo } from 'react'

//* Components
import Text from 'components/common/Text'
import Image from 'components/common/Image'
import CustomLink from 'components/common/CustomLink'

//* Styles
import MultiTypeListItemStyle from './style'

const MultiTypeListItem = Memo(({ featured_image, title, featured_description, slug }) => {
	return (
		<MultiTypeListItemStyle>
			<CustomLink url={slug}>
				<Image objectFit='cover' src={featured_image.url} alt={featured_image.alt} />

				<div className={`mtli-content-cont bgWhite`}>
					{title && <Text tag='h3' text={title} className={`mtli-title font-ping-bolder h6`} />}

					<Text tag='h4' text={featured_description} className={`mtli-description font-helvetica h6 p pS`} />
				</div>
			</CustomLink>
		</MultiTypeListItemStyle>
	)
})

export default MultiTypeListItem
